class MlvTranslation {
  keyNames() {
    return {
      NONE: 0,
      ADD_TO_CART: 682,
      CONFIGURATION_CODE: 1933,
      CONTACT_US: 127,
      COPY_TO_CLIPBOARD: 1934,
      ENTER_PART_NUMBER: 553,
      FIND_A_DISTRIBUTOR: 1935,
      LEAD_TIME: 1936,
      LOAD_SAVED_CONFIGURATION: 1937,
      PRICE: 462,
      PRODUCT_DESCRIPTION: 1938,
      PRODUCT_EXAMPLE: 1939,
      PRODUCT_SERIES_GENERAL_SPECIFICATIONS: 1940,
      QUANTITY: 88,
      REQUEST_QUOTE: 1941,
      RESET_SELECTIONS_TO_BASE_MODEL: 1942,
      SAVE_CONFIGURATION: 1943,
      SET_CONFIGURATIONS_BELOW: 1944,
      SHARE_CONFIGURATION: 1945,
      SHIPPING: 1946,
      SUPPORT_DOCUMENTS: 1947,
      USUALLY_WITHIN_2_BUSINESS_DAYS: 1948,
      VIEW_SUMMARY_SHEET: 1949,
      WHERE_TO_BUY: 796,
      SEARCH: 46,
      SAVE: 1075,
      PRINT: 1066,
      CLOSE: 676,
      DELETE: 1074,
      CANCEL: 404,
      SHARE: 1283,
      INVALID_EMAIL_ADDRESS: 1308,
      LOAD: 1953,
      ENTER_VALID_EMAIL: 144,
      NO_RESULTS_FOUND: 1478,
      CONFIG_NOT_VALID: 1954,
      ENTER_CONFIG_NAME: 1955,
      RESET_TO_DEFAULT: 1956,
      CONFIG_CODE_SEARCH: 1952,
      UPDATE: 798,
      INCONSITENT_VALUE: 1967,
      OPTION: 1963,
      YOUR_SELECTION: 1969,
      PROPOSED_CHANGE: 1966,
      ACCEPT_CHANGES_QUESTION: 1968,
      ACCEPT: 1742,
      PREVIEW_NOT_AVAILABLE: 1965,
      TELEPHONE: 370,
      FAX: 634,
      DONE: 1162,
      MODULE_STATIONS: 1962,
      EDIT_SECTION: 1960,
      ADD_STATION: 1957,
      PART_NUMBER: 1022,
      MOVE: 1090,
      DUPLICATE: 1959,
      INLET_STATION: 1961,
      OUTLET_STATION: 1964,
      EDIT: 1167,
      CONFIG_ENGINE_NOT_AVAILABLE: 1958,
      HOME: 791,
      CAD: 755,
      PREVIEW: 2987,
      FORMATS: 244,
      ALERT_MESSAGE_INFO: 3458,
      ALERT_MESSAGE_LOAD: 3459,
      ALERT_MESSAGE_SUCCESS: 3460,
      ALERT_MESSAGE_LOAD_PDF: 3461,
      ALERT_MESSAGE_SUCCESS_PDF: 3462,
      ALERT_MESSAGE_RESET: 3463,
      RESET_CAD: 58,
      GENERATE_CAD: 3464,
      GENERATE_DATA_SHEET_PDF: 3465,
      CAD_FILTER_ALL: 198,
      CAD_FILTER_ALL_3D: 3466,
      CAD_FILTER_ALL_2D: 3467,
      CAD_SELECT_TEXT: 3468,
      CAD_SELECT_2D: 3469,
      CAD_FORMAT_DOWNLOAD: 3507,
      REFRESH_CAD: 3350
    };
  }
}
export default new MlvTranslation();
